import ProductDefinitions from './products'
import ProductEnhancementsDefinitions from './products-enhancement'
import AboutDefinitions from './about'
import TerminalDefinitions from './terminals'
import IndustryDefinitions from './industry'
import FinancialDefinitions from './financial'
import PageHome from './home'
import KnowledgeHubDefinitions from './knowledgeHub'
import PartnersDefinitions from './partners'
import CharityDefinitions from './charity'
import CareersDefinitions from './careers'
import InvestorDefinitions from './investors'
import IndexDefinitions from './indexReports'
import UpliftDefinitions from './uplift'
import ProductUpdatesDefinitions from './product-updates'
import ContactDefinitions from './contact'
import OfficesDefinition from './offices'
import PlatformDirectoryDefinitions from './platform-directory'
import LandingDefinitions from './landing'
import SocialResponsibility from './socialResponsibility'
import ManualsDefinitions from './manuals'
import Newsletter from './newsletter'
import PagePaymentLookup from './payment-lookup'
import PodcastDefinitions from './podcast'
import SdrDefinitions from './sdr'
import EventsDefinitions from './events'

export default {
  ...PageHome,
  ...AboutDefinitions,
  ...TerminalDefinitions,
  ...ProductDefinitions,
  ...ProductEnhancementsDefinitions,
  ...IndustryDefinitions,
  ...FinancialDefinitions,
  ...KnowledgeHubDefinitions,
  ...PartnersDefinitions,
  ...CharityDefinitions,
  ...CareersDefinitions,
  ...InvestorDefinitions,
  ...IndexDefinitions,
  ...UpliftDefinitions,
  ...ProductUpdatesDefinitions,
  ...ContactDefinitions,
  ...OfficesDefinition,
  ...PlatformDirectoryDefinitions,
  ...LandingDefinitions,
  ...SocialResponsibility,
  ...ManualsDefinitions,
  ...Newsletter,
  ...PodcastDefinitions,
  ...SdrDefinitions,
  ...PagePaymentLookup,
  ...EventsDefinitions
}
